import { useReveal } from "@/lib/useReveal";

/**
 * Wrap any content to fade-up when it scrolls into view.
 *
 *   <Reveal as="section" className="…">…</Reveal>
 *   <Reveal stagger className="grid …">…</Reveal>   // children stagger via --i
 */
export default function Reveal({
  as: Tag = "div",
  className = "",
  stagger = false,
  children,
  ...props
}) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      data-stagger={stagger ? "" : undefined}
      className={`kpp-reveal ${visible ? "is-visible" : ""} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
}

/**
 * Wraps plain text and splits it word-by-word into animated spans.
 * Used by the hero H1 to stagger each word. Preserves the original
 * text (including punctuation and ampersands) exactly.
 */
export function WordStagger({ children, startIndex = 0 }) {
  const text = String(children);
  const words = text.split(/(\s+)/); // keep spaces as separate tokens
  let wordIndex = 0;
  return words.map((token, i) => {
    if (/^\s+$/.test(token)) return token; // pass-through whitespace
    const idx = startIndex + wordIndex;
    wordIndex += 1;
    return (
      <span key={i} className="kpp-word" style={{ "--i": idx }}>
        {token}
      </span>
    );
  });
}
